import { createReducer } from 'redux-act';

const STANDARD_TEMPLATE = 'standard';

const initState = {
  makeCustomTemplateDict: {
    // Alfa-Romeo
    'a10ee0ec-d39e-8607-f74d-907c3e05d4a3': 'alfa-romeo',
    // Cadillac
    '6f144170-42b4-00f5-e6fa-e7f3836b7aad': 'cadillac',
    // Infiniti
    '72f725ec-b7f5-a9fc-0d9a-b6343ab87d93': 'infiniti',
    // Jaguar
    '9ecc9a10-3e4a-c155-c688-31ad2e8b957b': 'jaguar',
    // Land Rover
    'eafbfaf9-3954-23d1-7a71-ea74581a1ecf': 'landrover',
    // Mercedes-Benz
    '1f4a547c-4025-eb78-5d29-45cfe0d59f85': 'mercedes',
    // MINI
    'ed2da2f1-d2fe-fd8e-5495-7a63d7db6cd2': 'mini',
    // Porsche
    'dfd0b9a8-9179-e9b7-2c2b-448a75df2725': 'porsche',
  },
};

export const getTemplateFromMakeId = (makeId, templatesStore) => templatesStore.makeCustomTemplateDict[makeId] || STANDARD_TEMPLATE;

export default createReducer({}, initState);



// WEBPACK FOOTER //
// ./src/templates/display/data/templates.js